export enum MiterType {
  NONE = 0,
  START = 1,
  END = 2,
  BOTH = 3,
}
